import { Injectable } from '@angular/core';

/**
 * Um popover do rail aberto por vez em TODA a folha, não só dentro do card.
 *
 * O rail de cada card para a propagação do clique (`$event.stopPropagation()` no
 * `.card-toolbar`), então o `clickOutside` de um menu aberto em outro card nunca via o
 * clique no ⋯ vizinho e os dois ficavam abertos juntos. Quem abre registra aqui como
 * se fecha; abrir outro fecha o anterior.
 */
@Injectable({ providedIn: 'root' })
export class RailPopoverService {
    private _close: (() => void) | null = null;

    /** Registra o popover que acabou de abrir e fecha o que estava aberto. Devolve o "soltar". */
    public open(close: () => void): () => void {
        const previous = this._close;
        this._close = close;
        if (previous && previous !== close) previous();

        return () => {
            if (this._close === close) this._close = null;
        };
    }
}
